module.exports = __webpack_public_path__ + "media/images/icons/document_back-e968b27081c66718679dc9a46fd003e1.png";